export default "__VITE_ASSET__BudF6_W5__"